import type { CourseSummary } from "./types";

export type CourseScope = "mine" | "same-level" | "all";

const activeCourseStatuses = new Set(["OPEN", "IN_PROGRESS"]);

export function matchingCourseTypes(courses: readonly CourseSummary[]): Set<string> {
  return new Set(courses.filter((course) => course.isAssignedToCurrentUser).map((course) => course.courseTypeCode));
}

export function coursesForScope(courses: readonly CourseSummary[], scope: CourseScope): CourseSummary[] {
  if (scope === "all") return [...courses];
  if (scope === "mine") return courses.filter((course) => course.isAssignedToCurrentUser);
  const matchingTypes = matchingCourseTypes(courses);
  return courses.filter((course) => !course.isAssignedToCurrentUser && activeCourseStatuses.has(course.status) && matchingTypes.has(course.courseTypeCode));
}

export function filterCourses(courses: readonly CourseSummary[], scope: CourseScope, search: string): CourseSummary[] {
  const normalizedSearch=search.trim().toLocaleLowerCase();
  return coursesForScope(courses,scope).filter((course)=>!normalizedSearch||course.title.toLocaleLowerCase().includes(normalizedSearch)||course.courseTypeCode.replaceAll("_"," ").toLocaleLowerCase().includes(normalizedSearch));
}
